import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import moment from 'moment';
import styled from 'styled-components';
import ListTable from '../../../common/tables/ListTable';
import TableDefinitions from '../../../common/TableDefinitions';
import { tableLoadData } from '../../../common/tables/actions/ListTableActions';
import {
  getColumns,
  getData,
  getEDIRFIDColumns,
  getEDIRFIDData,
  getIsLoading,
  getTotalColumns,
  getTotalData,
  getTotalFilteredEDIRFIDData,
  getFilteredData,
  getTotalFilteredData,
} from '../redux/selectors/DailyRouteLeadingCountStatusListSelectors';
import { getAssetType } from '../../../common/asset-types/redux/selectors/AssetTypesSelectors';
import {
  getLeftCheckedMailProcessingCenters,
  getRightCheckedMailProcessingCenters,
} from '../../../common/user/redux/selectors/UserDataSelectors';
import DailyRouteLeadingCountStatusSelectionCriteriaContainer
  from './DailyRouteLeadingCountStatusSelectionCriteriaContainer';
import { DailyRouteLeadingCountStatusStyles } from './DailyRouteLeadingCountStatusListStyles';
import downloadTypes from '../../../common/tables/excel/DownloadTypes';
import {
  postDailyRouteLeadingCountUseEdiRequestActionCreator,
  postDailyRouteLeadingCountUseMaxRequestActionCreator,
} from '../use-edi-or-max/redux/actions/DailyRouteLeadingCountUseEdiOrUseMaxActions';
import { getGlobalEndDate, getGlobalStartDate } from '../../../common/selection-criteria/period/redux/selectors/GlobalPeriodSelectionSelectors';
import { setGlobalEndDateSelectionActionCreator, setGlobalStartDateSelectionActionCreator } from '../../../common/selection-criteria/period/redux/actions/GlobalPeriodSelectionActions';

const StyledComponentContainer = styled.div`${DailyRouteLeadingCountStatusStyles}`;
StyledComponentContainer.displayName = 'StyledComponentContainer';

const leftTree = {
  title: 'Outbound Operator & IMPC',
  useGlobalPresets: false,
};
const rightTree = {
  title: 'Inbound Operator & IMPC',
  useGlobalPresets: false,
};

class DailyRouteLeadingCountStatusListContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showResult: false,
      selectedStartDate: this.props.globalStartDate,
      selectedEndDate: this.props.globalEndDate,
    };
  }

  onStartDateChange = (newDate) => {
    this.setState({
      selectedStartDate: newDate,
    });
    this.props.setGlobalStartDateSelectionActionCreator(newDate);
  }

  onEndDateChange = (newDate) => {
    this.setState({
      selectedEndDate: newDate,
    });
    this.props.setGlobalEndDateSelectionActionCreator(newDate);
  }

  onCriteriaApply = () => {
    this.setState({
      showResult: true,
    });

    this.props.tableLoadData(
      { tableId: TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id },
      this.props.appContext.appContext,
      {
        impcFromList: this.props.leftCheckedMailProcessingCenters,
        impcToList: this.props.rightCheckedMailProcessingCenters,
        startDate: moment(this.state.selectedStartDate).format('YYYY-MM-DD'),
        endDate: moment(this.state.selectedEndDate).format('YYYY-MM-DD'),
      },
    );
  };

  onClickCell = (state, rowInfo) => {
    if (rowInfo && rowInfo.row) {
      return {
        onClick: (e, handleOriginal) => {
          if (handleOriginal) {
            if (e.currentTarget.textContent === 'Use EDI') {
              this.props.postDailyRouteLeadingCountUseEdiRequestActionCreator(rowInfo.row.assetRouteId, rowInfo.row.date);
              this.props.tableLoadData(
                { tableId: TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id },
                this.props.appContext.appContext,
                {
                  impcFromList: this.props.leftCheckedMailProcessingCenters,
                  impcToList: this.props.rightCheckedMailProcessingCenters,
                  startDate: moment(this.state.selectedStartDate).format('YYYY-MM-DD'),
                  endDate: moment(this.state.selectedEndDate).format('YYYY-MM-DD'),
                },
              );
            } else if (e.currentTarget.textContent === 'Use Max') {
              this.props.postDailyRouteLeadingCountUseMaxRequestActionCreator(rowInfo.row.assetRouteId, rowInfo.row.date);
              this.props.tableLoadData(
                { tableId: TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id },
                this.props.appContext.appContext,
                {
                  impcFromList: this.props.leftCheckedMailProcessingCenters,
                  impcToList: this.props.rightCheckedMailProcessingCenters,
                  startDate: moment(this.state.selectedStartDate).format('YYYY-MM-DD'),
                  endDate: moment(this.state.selectedEndDate).format('YYYY-MM-DD'),
                },
              );
            }
          }
        },
      };
    }
    return {};
  };

  render() {
    const { showResult, selectedStartDate, selectedEndDate } = this.state;
    const {
      isLoading,
      data,
      columns,
      columnsTotal,
      dataTotal,
      columnsEDIRFID,
      dataEDIRFID,
      totalFilteredEDIRFIDData,
      filteredData,
      totalFilteredData,
    } = this.props;

    return (
      <div>
        <DailyRouteLeadingCountStatusSelectionCriteriaContainer
          open={data.length === 0}
          title="DAILY ROUTE LEADING COUNT STATUS"
          selectedStartDate={selectedStartDate}
          onStartDateChange={this.onStartDateChange}
          selectedEndDate={selectedEndDate}
          onEndDateChange={this.onEndDateChange}
          onApply={this.onCriteriaApply}
          leftTree={leftTree}
          rightTree={rightTree}
        />
        <StyledComponentContainer>
          <div className="general-content-container" style={{ flexDirection: 'column' }}>
            {(showResult || data.length > 0) && (
              <>
                <div className="full-width">
                  <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                    <ListTable
                      listId={TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id}
                      loading={isLoading}
                      columns={columns}
                      data={data}
                      keyField="id"
                      selectCheckbox
                      pagination
                      downloadType={downloadTypes.EXCEL}
                      getTdProps={this.onClickCell}
                    />
                  </div>
                </div>
                <div>
                  <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                    <ListTable
                      listId={TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id}
                      loading={isLoading}
                      columns={columnsTotal}
                      data={filteredData.length > 0 ? totalFilteredData : dataTotal}
                      keyField="id"
                    />
                  </div>
                </div>
                <div>
                  <div className="list-table-container" style={{ paddingBottom: '20px' }}>
                    <ListTable
                      listId={TableDefinitions.DAILY_ROUTE_LEADING_COUNT_STATUS_PAGE.id}
                      loading={isLoading}
                      columns={columnsEDIRFID}
                      data={filteredData.length > 0 ? totalFilteredEDIRFIDData : dataEDIRFID}
                      keyField="used"
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        </StyledComponentContainer>
      </div>
    );
  }
}

DailyRouteLeadingCountStatusListContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  dataTotal: PropTypes.arrayOf(PropTypes.object),
  totalFilteredData: PropTypes.arrayOf(PropTypes.object),
  filteredData: PropTypes.arrayOf(PropTypes.object),
  totalFilteredEDIRFIDData: PropTypes.arrayOf(PropTypes.object),
  columnsTotal: PropTypes.arrayOf(PropTypes.object),
  dataEDIRFID: PropTypes.arrayOf(PropTypes.object),
  columnsEDIRFID: PropTypes.arrayOf(PropTypes.object),
  leftCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  rightCheckedMailProcessingCenters: PropTypes.arrayOf(PropTypes.string),
  tableLoadData: PropTypes.func,
  appContext: PropTypes.objectOf(PropTypes.string),
  isLoading: PropTypes.bool,
  postDailyRouteLeadingCountUseEdiRequestActionCreator: PropTypes.func,
  postDailyRouteLeadingCountUseMaxRequestActionCreator: PropTypes.func,
  globalStartDate: PropTypes.instanceOf(Date),
  globalEndDate: PropTypes.instanceOf(Date),
  setGlobalStartDateSelectionActionCreator: PropTypes.func,
  setGlobalEndDateSelectionActionCreator: PropTypes.func,
};

function mapStateToProps(state) {
  return {
    data: getData(state),
    columns: getColumns(state),
    dataTotal: getTotalData(state),
    columnsTotal: getTotalColumns(state),
    dataEDIRFID: getEDIRFIDData(state),
    columnsEDIRFID: getEDIRFIDColumns(state),
    appContext: getAssetType(state),
    leftCheckedMailProcessingCenters: getLeftCheckedMailProcessingCenters(state),
    rightCheckedMailProcessingCenters: getRightCheckedMailProcessingCenters(state),
    isLoading: getIsLoading(state),
    globalStartDate: getGlobalStartDate(state),
    globalEndDate: getGlobalEndDate(state),
    totalFilteredData: getTotalFilteredData(state),
    filteredData: getFilteredData(state),
    totalFilteredEDIRFIDData: getTotalFilteredEDIRFIDData(state),
  };
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  tableLoadData,
  postDailyRouteLeadingCountUseEdiRequestActionCreator,
  postDailyRouteLeadingCountUseMaxRequestActionCreator,
  setGlobalStartDateSelectionActionCreator,
  setGlobalEndDateSelectionActionCreator,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(DailyRouteLeadingCountStatusListContainer);
